/* ==========================================================================
   ASK FORM – SHARED FILE (identical on all 5 stores)
   Drives snippets/ask-form.liquid: the whole form is visible at once.
   - The problem list depends on country + stage (data from ask-sites.liquid,
     <script id="ask-data">). Country-specific problems come first.
   - Prefill from the URL: ?country=sweden&stage=money&p=M1&from=handle
   - Source tracking (?from= or the previous page on the same site).
   - Checks before sending, then success message after Shopify's redirect.
   ========================================================================== */
(function () {
  if (window.__askInit) return; window.__askInit = true;

  var DATA = { common: { stages: [], base: {} }, countries: [] };
  function loadData() {
    var el = document.getElementById('ask-data');
    if (!el) return;
    try { DATA = JSON.parse(el.textContent); } catch (e) {}
  }
  function store(k, v) { try { if (v === undefined) return JSON.parse(sessionStorage.getItem(k) || 'null'); sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) { return null; } }
  var params = new URLSearchParams(location.search);
  var FOREIGN = /foreign|permit|permission|allowed|nationality|passport|non-eu|land/i;

  function countryBy(h) { for (var i = 0; i < DATA.countries.length; i++) if (DATA.countries[i].h === h) return DATA.countries[i]; return null; }
  function problemsFor(h, stage) {
    var c = countryBy(h), out = [];
    if (c && c.add && c.add[stage]) c.add[stage].forEach(function (p) { out.push(p); });
    (DATA.common.base[stage] || []).forEach(function (p) { out.push(p); });
    out.push(['Z', 'Something else']);
    return out;
  }
  function resolveP(h, p) {
    if (!p) return null;
    var c = countryBy(h), st, i, list;
    if (p === 'foreign') {
      var order = ['explore', 'money', 'found'];
      for (i = 0; i < order.length; i++) {
        list = (c && c.add && c.add[order[i]]) || [];
        for (var j = 0; j < list.length; j++) if (FOREIGN.test(list[j][1])) return [order[i], list[j][1]];
      }
      return ['money', 'Residence permit or visa'];
    }
    for (st in DATA.common.base) {
      list = DATA.common.base[st];
      for (i = 0; i < list.length; i++) if (list[i][0] === p) return [st, list[i][1]];
    }
    return null;
  }
  function sourceFromReferrer() {
    if (params.get('from')) return params.get('from');
    try {
      var r = document.referrer ? new URL(document.referrer) : null;
      if (r && r.host === location.host) {
        if (r.pathname === '/') return 'home';
        var parts = r.pathname.split('/').filter(Boolean);
        return parts[parts.length - 1] || r.pathname;
      }
      if (r) return 'external: ' + r.host;
    } catch (e) {}
    return 'direct';
  }

  function init(wrap) {
    var fid = wrap.getAttribute('data-fid');
    var form = wrap.querySelector('form');
    if (!form) return;
    var $ = function (s) { return wrap.querySelector(s); };
    var cSel = $('[data-ask-country]'), sSel = $('[data-ask-stage]'), pSel = $('[data-ask-problem]');
    var msg = $('[data-ask-msg]'), errEl = $('[data-ask-err]'), src = $('[data-ask-source]');
    var em = form.querySelector('input[type="email"]');

    if (src && !src.value) src.value = sourceFromReferrer();

    function opt(sel) { return sel && sel.selectedIndex > -1 ? sel.options[sel.selectedIndex] : null; }
    function cH() { var o = opt(cSel); return o ? (o.getAttribute('data-h') || '') : ''; }
    function cName() { var o = opt(cSel); return o && o.value && o.value !== 'Other' ? o.value : ''; }
    function stK() { var o = opt(sSel); return o ? (o.getAttribute('data-k') || '') : ''; }
    function paint(sel) { if (sel) sel.classList.toggle('is-empty', !sel.value); }
    function bad(el, on) { var f = el && el.closest('.ask-fld'); if (f) f.classList.toggle('is-bad', !!on); }
    function showErr(t) { if (!errEl) return; errEl.textContent = t || ''; errEl.hidden = !t; }

    function buildProblems(pick) {
      if (!pSel) return;
      var keep = pick || pSel.value, st = stK(), h = cH();
      pSel.innerHTML = '';
      var first = document.createElement('option'); first.value = '';
      if (!cSel.value || !st) {
        first.textContent = !cSel.value && !st ? 'Pick your country and stage first' : (!cSel.value ? 'Pick your country first' : 'Pick your stage first');
        pSel.appendChild(first); pSel.disabled = true; paint(pSel); return;
      }
      first.textContent = 'Pick the closest one';
      pSel.appendChild(first);
      var name = cName(), list = problemsFor(h, st), grp = null, local = [], rest = [];
      list.forEach(function (p) { (p[0].charAt(0) === 'X' ? local : rest).push(p); });
      function add(parent, p) {
        var o = document.createElement('option'); o.value = p[1]; o.textContent = p[1];
        if (keep && keep === p[1]) o.selected = true;
        parent.appendChild(o);
      }
      if (local.length && name) {
        grp = document.createElement('optgroup'); grp.label = 'Common in ' + name;
        local.forEach(function (p) { add(grp, p); }); pSel.appendChild(grp);
        var g2 = document.createElement('optgroup'); g2.label = 'Anywhere';
        rest.forEach(function (p) { add(g2, p); }); pSel.appendChild(g2);
      } else {
        local.concat(rest).forEach(function (p) { add(pSel, p); });
      }
      pSel.disabled = false; paint(pSel);
    }

    wrap.addEventListener('change', function (e) {
      var t = e.target;
      if (t === cSel || t === sSel) buildProblems();
      paint(t.tagName === 'SELECT' ? t : null);
      if (t.value) bad(t, false);
      showErr('');
    });
    if (msg) msg.addEventListener('input', function () { if (msg.value.trim().length >= 30) bad(msg, false); });
    if (em) em.addEventListener('input', function () { bad(em, false); });

    form.addEventListener('submit', function (e) {
      var first = null, why = '';
      function fail(el, t) { bad(el, true); if (!first) { first = el; why = t; } }
      if (cSel && !cSel.value) fail(cSel, 'Pick a country (or "Somewhere else").');
      if (sSel && !sSel.value) fail(sSel, 'Tell us where you’re at.');
      if (pSel && !pSel.value) fail(pSel, 'Pick the problem closest to yours.');
      if (msg && msg.value.trim().length < 30) fail(msg, 'Tell us a bit more about your situation: a couple of sentences at least.');
      if (em && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em.value.trim())) fail(em, 'That email doesn’t look right.');
      if (first) {
        e.preventDefault(); showErr(why);
        try { first.focus({ preventScroll: true }); } catch (x) {}
        first.closest('.ask-fld').scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      store('ask_sent', { fid: fid, stage: stK(), t: Date.now() });
      var btn = form.querySelector('.ask-send'); if (btn) { btn.disabled = true; btn.classList.add('is-busy'); }
    });

    /* Prefill from the URL (country from the page wins if already set) */
    var pc = params.get('country');
    if (pc && cSel && !cSel.value) {
      for (var i = 0; i < cSel.options.length; i++) if (cSel.options[i].getAttribute('data-h') === pc) { cSel.selectedIndex = i; break; }
    }
    var rp = resolveP(cH(), params.get('p'));
    var ps = (rp && rp[0]) || params.get('stage');
    if (ps && sSel) { for (var k = 0; k < sSel.options.length; k++) if (sSel.options[k].getAttribute('data-k') === ps) { sSel.selectedIndex = k; break; } }
    buildProblems(rp ? rp[1] : null);
    paint(cSel); paint(sSel);

    /* After Shopify's redirect (?contact_posted=true) */
    var done = $('.ask-done'), body = $('.ask-body');
    if (done) {
      var sent = store('ask_sent');
      if (sent && sent.fid && sent.fid !== fid) { done.hidden = true; if (body) body.hidden = false; }
      else {
        setTimeout(function () { wrap.scrollIntoView({ behavior: 'smooth', block: 'center' }); try { done.focus({ preventScroll: true }); } catch (e) {} }, 250);
        document.dispatchEvent(new CustomEvent('ask:sent', { detail: { stage: sent ? sent.stage : '', fid: fid } }));
      }
    }
  }

  function boot() { loadData(); [].forEach.call(document.querySelectorAll('[data-ask]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
